import React, {Component} from 'react'
import { numberWithCommas } from '../../fiches';

import {Link} from 'react-router-dom'

export default class PreviewHistory extends Component {
    constructor (props) {
        super(props);

        this.direction = {
            output: '-',
            input: '+',
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    convertDate = (timestamp) => {
        return new Date(timestamp*1000);
    }

    addressReduction = (address) => {
        if (typeof address === "string") {
            if (address.length > 15) {
                return address.substr(0,8)+'...'+address.substr(address.length-6);
            } else {
                return address
            }
        }
        return ""
    }

    render() {
        return(
            <div className="preview-history">
                <h2>{this.translation['History']}</h2>
                <div className="table table-history">
                    {
                        this.props.history.map((listItem, index) => {
                            let date = this.convertDate(listItem.timestamp);
                            return (
                                <div className="table_row" key={index}>
                                    <div className="transaction-date">{date.getDate() < 10 ? '0'+date.getDate() : date.getDate()}.{date.getMonth() < 9 ? '0'+(date.getMonth()+1) : date.getMonth()+1}.{date.getFullYear()%100}</div>
                                    <div className="transaction-time">{date.getHours() == 0 ? '00' : date.getHours() < 10 ? '0'+date.getHours() : date.getHours()}:{date.getMinutes() == 0 ? '00' : date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()}</div>
                                    <div className={`transfer ${listItem.blockchain === 'DEPO' ? 'lowercase' : ''}`}>{this.direction[listItem.direction]} {numberWithCommas(listItem.amount)} {listItem.currency}</div>
                                    <div className="description">{this.addressReduction(listItem.address)}</div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="preview-history_links">
                    <Link className={`link link_all-trans ${this.props.ecoAddress ? '' : 'link_full'}`} to="/investor/history">{this.translation['Show all transactions']}</Link>
                    {this.props.ecoAddress ?
                    <a className="link" href={`https://eco.cryptaur.com/wallet/${this.props.ecoAddress}`} target="_blank">eco.cryptaur.com</a> :
                    null}
                </div>
            </div>
        )
    }
}